import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef } from 'react';
import { Button, } from '../../index.js';
import styles from './icon-button.module.css';
export const IconButton = forwardRef(({ as, className, icon, dimension, kind, disabled, busy, ...otherProps }, forwardedRef) => (_jsx(Button, { ref: forwardedRef, icon: icon, dimension: dimension, kind: kind, as: as, disabled: disabled, busy: busy, className: clsx(styles.IconButton, className), iconOpticalSize: {
        big: 24,
    }, ...otherProps })));
